import { AttachmentIcon } from "@chakra-ui/icons";
import { Flex, Icon, Input, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getFile } from "../../api/files";

const FileList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FileItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #ccc;
  margin-bottom: 4px;
  border-radius: 4px;
`;

const RemoveButton = styled.button`
  background-color: #f44336;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: #d32f2f;
  }
`;

const FileInputContainer = styled.div`
  margin-bottom: 10px;
`;

const FileName = styled(Text)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: #3182ce;
  }
`;

interface FileUploaderProps {
  onChange: (files: File[]) => void;
  onChangeDeletedIds?: (ids: number[]) => void;
  currentFiles?: any[]
  handleSingleFileDelete?: (arg: string) => void
  isAnnexPage?: boolean
  singleFile?: boolean
}

const FileUploader = ({ onChange, currentFiles = [], onChangeDeletedIds, handleSingleFileDelete, isAnnexPage = false, singleFile = false }: FileUploaderProps) => {
  const [files, setFiles] = useState<any>([]);
  const [deletedIds, setDeletedIds] = useState<number[]>([])
  const [currentFilesList, setCurrentFilesList] = useState(() => currentFiles);
  const prevCurrentFilesRef = useRef<any[]>(currentFiles);

  useEffect(() => {
    const areArraysEqual = (arr1: any[], arr2: any[]): boolean => {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    };

    if (!areArraysEqual(currentFiles, prevCurrentFilesRef.current)) {
      setCurrentFilesList(currentFiles);
      prevCurrentFilesRef.current = currentFiles;
    }
  }, [currentFiles]);

  const handleFileChange = (event: any) => {
    const newFiles = Array.from(event.target.files);
    if (singleFile) {
      setFiles(newFiles[0] ? [newFiles[0]] : [])
    } else {
      setFiles((prevFiles: any) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (indexToRemove: any) => {
    setFiles((prevFiles: any) =>
      prevFiles.filter((_: any, index: any) => index !== indexToRemove)
    );
  };
  const handleRemoveCurrentFile = (file: any, indexToRemove: number) => {
    setCurrentFilesList((prevFiles: any) =>
      prevFiles.filter((_: any, index: any) => index !== indexToRemove)
    );
    handleSingleFileDelete && handleSingleFileDelete(file.id)
    setDeletedIds && setDeletedIds((prevItems) => [...prevItems, file.id]);
  };

  const handleDownloadFile = async (file: any) => {
    if (isAnnexPage) {
      if (file.isCurrentFile) {
        try {
          const response = await getFile(file.downloadId);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', file.name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Ошибка при скачивании файла:', error);
        }
      } else {
        // Для новых файлов
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    }
  };

  useEffect(() => {
    onChange(files)
  }, [files])

  useEffect(() => {
    onChangeDeletedIds && onChangeDeletedIds(deletedIds)
  }, [deletedIds])


  return (
    <Flex flexDirection="column">
      <Text pointerEvents="none" >Вложения</Text>
      <FileInputContainer>
        <Flex
          border="1px dashed #E2E8F0"
          height="60px"
          alignItems="center"
          padding="16px"
          position="relative"
          overflow="hidden"
          borderRadius="md"
          cursor="pointer"
          paddingLeft="10px"
          _hover={{
            bg: "gray.100",
          }}
          flexDirection="row"
          justifyContent="center"
        >
          <Icon as={AttachmentIcon} mr="2" color="gray.500" />
          <Text>
            Перетяните сюда или выберите файл
          </Text>
          <Input
            type="file"
            opacity="0"
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            cursor="pointer"
            zIndex="1"
            multiple
            onChange={handleFileChange}
          />
        </Flex>

      </FileInputContainer>

      {((currentFilesList.length > 0 || files.length > 0)) && (
        <>
          <Text>Загруженные файлы:</Text>
          <FileList>
            {!isAnnexPage && files.map((file: any, index: any) => (
              <FileItem key={index}>
                <FileName maxW="250px" noOfLines={1} onClick={() => singleFile && handleDownloadFile(file)}>{file.name}</FileName>
                <RemoveButton onClick={() => handleRemoveFile(index)}>
                  Удалить
                </RemoveButton>
              </FileItem>
            ))}
            {currentFilesList.map((file: any, index: any) => (
              <FileItem key={index}>
                <FileName maxW="250px" noOfLines={1} onClick={() => handleDownloadFile(file)}>{file.name}</FileName>
                <RemoveButton onClick={() => handleRemoveCurrentFile(file, index)}>
                  Удалить
                </RemoveButton>
              </FileItem>
            ))}
          </FileList>
        </>
      )}
    </Flex>
  );
};

export default FileUploader;
